import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosMedia } from "../../../../modules/content/components/StratosMedia/StratosMedia";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { IImageBlockProps } from "./ImageBlock.props";

export const ImageBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IImageBlockProps) => {
  if (!image) return null;

  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <StratosCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="rounded-[20px] bg-sunlit p-3 md:p-5">
          <StratosMedia
            aspectRatio={image.aspectRatio}
            className="shadow-[0_24px_60px_-40px_rgb(16_23_34/0.7)]"
            media={image.image}
            sizes="(min-width: 1280px) 1120px, calc(100vw - 48px)"
          />
        </div>
      </div>
    </StratosSection>
  );
};

ImageBlock.displayName = "Block::ImageBlock";
